import React from "react";
import { Image } from "react-bootstrap";

import {
  EMPTY_ARRAY_LENGTH,
  customerSurveyConstants,
} from "../../../../constants";

const QuestionHeadingLogo = (props) => {
  const logoTheme = props.brandDetail?.logoTheme;

  return (
    <div
      className={`ps-4 d-flex justify-content-center align-items-center survey-logo py-3`}
    >
      {logoTheme && logoTheme.length > EMPTY_ARRAY_LENGTH ? (
        <div className="survey-theme-logo-wrap justify-content-center align-items-center d-flex ">
          <Image src={logoTheme} className="survey-theme-logo" />
        </div>
      ) : (
        <Image
          src={props.brandDetail?.logoURL}
          fluid
          width={customerSurveyConstants.SURVEY_LOGO_WIDTH_PX}
        />
      )}
    </div>
  );
};

export default QuestionHeadingLogo;
